export default __webpack_public_path__ + "static/media/Killer.37e9b707.jpg";